import { GiEmailAttachment, GiEmailAttachmentJson } from '@gi/models/gi-email-attachment';
import { EmailFrom, EmailFromJson } from '@models/email-from';

export interface GiEmailTemplateJson {
  body: string;
  cc: string[];
  cci: string[];
  from: string;
  from_name: string;
  subject: string;
  to: string[];
  reply_to: string | null;
  attachments: Partial<GiEmailAttachmentJson>[];
  froms?: EmailFromJson[];
}

export class GiEmailTemplate {
  constructor(
    public body: string,
    public cc: string[],
    public cci: string[],
    public from: string,
    public fromName: string,
    public subject: string,
    public to: string[],
    public replyTo: string | null,
    public attachments: GiEmailAttachment[] = [],
    public froms?: EmailFrom[]
  ) {}

  static fromJson(json: Partial<GiEmailTemplateJson>): GiEmailTemplate {
    return new GiEmailTemplate(
      json.body,
      json.cc,
      json.cci,
      json.from,
      json.from_name,
      json.subject,
      json.to,
      json.reply_to,
      (json.attachments ?? []).map((j: GiEmailAttachmentJson) => GiEmailAttachment.fromJson(j)),
      (json.froms ?? []).map((j: EmailFromJson) => EmailFrom.fromJson(j))
    );
  }

  static toJson(email: GiEmailTemplate): Partial<GiEmailTemplateJson> {
    return {
      body: email.body,
      cc: email.cc,
      cci: email.cci,
      from: email.from,
      from_name: email.fromName,
      subject: email.subject,
      to: email.to,
      reply_to: email.replyTo,
      attachments: (email.attachments ?? []).map((attachment: GiEmailAttachmentJson) =>
        GiEmailAttachment.toJson(attachment)
      )
    };
  }
}
